(function () {
  var body = document.body;
  var header = document.querySelector("[data-site-header]");
  var menuToggle = document.querySelector("[data-mobile-toggle]");
  var menuClose = document.querySelector("[data-mobile-close]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  var mobileBackdrop = document.querySelector("[data-mobile-backdrop]");
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var themeStrings = { addToCart: "加入購物車", soldOut: "售完" };
  var themeStringsScript = document.getElementById("LumiThemeStrings");

  if (themeStringsScript) {
    try {
      themeStrings = Object.assign(themeStrings, JSON.parse(themeStringsScript.textContent || "{}"));
    } catch (error) {
      themeStrings = { addToCart: "加入購物車", soldOut: "售完" };
    }
  }

  var progress = document.createElement("div");
  progress.className = "la-scroll-progress";
  progress.setAttribute("aria-hidden", "true");
  document.body.appendChild(progress);

  var cursorGlow = document.createElement("div");
  cursorGlow.className = "la-cursor-glow";
  cursorGlow.setAttribute("aria-hidden", "true");
  document.body.appendChild(cursorGlow);

  function syncHeaderState() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  }

  function syncScrollProgress() {
    var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    var progressValue = maxScroll > 0 ? window.scrollY / maxScroll : 0;
    progress.style.transform = "scaleX(" + Math.min(Math.max(progressValue, 0), 1) + ")";
  }

  function closeMobileMenu() {
    body.classList.remove("mobile-menu-open");

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "false");
    }

    if (mobileNav) {
      mobileNav.setAttribute("aria-hidden", "true");
      mobileNav.classList.remove("is-open");
    }

    if (mobileBackdrop) {
      mobileBackdrop.classList.remove("is-open");
    }
  }

  function openMobileMenu() {
    body.classList.add("mobile-menu-open");

    if (menuToggle) {
      menuToggle.setAttribute("aria-expanded", "true");
    }

    if (mobileNav) {
      mobileNav.setAttribute("aria-hidden", "false");
      mobileNav.classList.add("is-open");
    }

    if (mobileBackdrop) {
      mobileBackdrop.classList.add("is-open");
    }
  }

  function toggleMobileMenu() {
    if (body.classList.contains("mobile-menu-open")) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  }

  syncHeaderState();
  syncScrollProgress();

  window.addEventListener("scroll", syncHeaderState, { passive: true });
  window.addEventListener("scroll", syncScrollProgress, { passive: true });
  window.addEventListener("resize", syncScrollProgress);

  /* =========================================================
     FINAL FIX:
     手機 menu 打開後，如果視窗放大到桌機版，自動關閉 sidebar
  ========================================================= */

  var mobileMenuDesktopMedia = window.matchMedia("(min-width: 981px)");

  function closeMobileMenuOnDesktop() {
    if (!mobileMenuDesktopMedia.matches) return;
    closeMobileMenu();
  }

  window.addEventListener("resize", closeMobileMenuOnDesktop);

  if (mobileMenuDesktopMedia.addEventListener) {
    mobileMenuDesktopMedia.addEventListener("change", closeMobileMenuOnDesktop);
  } else if (mobileMenuDesktopMedia.addListener) {
    mobileMenuDesktopMedia.addListener(closeMobileMenuOnDesktop);
  }

  document.querySelectorAll("[data-language-select]").forEach(function (select) {
    select.addEventListener("change", function () {
      if (window.localStorage) {
        window.localStorage.setItem("lumi_locale_auto_selected", select.value || "manual");
      }

      if (select.form) select.form.submit();
    });
  });

  (function autoSelectVisitorLanguage() {
    var autoLocaleKey = "lumi_locale_auto_selected";
    if (window.localStorage && window.localStorage.getItem(autoLocaleKey)) return;

    var select = document.querySelector("[data-language-select]");
    if (!select || !select.form) return;

    var available = Array.prototype.slice.call(select.options).map(function (option) {
      return option.value;
    });

    var current = select.value;
    var country = (document.documentElement.getAttribute("data-country") || "").toUpperCase();
    var countryLocaleMap = {
      TW: ["zh-TW", "zh-Hant", "zh"],
      HK: ["zh-TW", "zh-Hant", "zh"],
      MO: ["zh-TW", "zh-Hant", "zh"],
      JP: ["ja", "ja-JP"],
      KR: ["ko", "ko-KR"],
      ES: ["es", "es-ES"],
      MX: ["es", "es-MX", "es"],
      AR: ["es", "es-AR", "es"],
      CO: ["es", "es-CO", "es"],
      CL: ["es", "es-CL", "es"],
      PE: ["es", "es-PE", "es"],
      SA: ["ar", "ar-SA"],
      AE: ["ar", "ar-AE"],
      QA: ["ar", "ar-QA"],
      KW: ["ar", "ar-KW"],
      EG: ["ar", "ar-EG"],
      US: ["en", "en-US"],
      GB: ["en", "en-GB"],
      CA: ["en", "en-CA"],
      AU: ["en", "en-AU"],
      SG: ["en", "en-SG"]
    };
    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    var target = "";

    function pickAvailable(candidates) {
      return candidates.some(function (candidate) {
        if (available.indexOf(candidate) > -1) {
          target = candidate;
          return true;
        }

        var base = (candidate || "").split("-")[0];
        if (base && available.indexOf(base) > -1) {
          target = base;
          return true;
        }

        return false;
      });
    }

    if (country && countryLocaleMap[country]) {
      pickAvailable(countryLocaleMap[country]);
    }

    if (!target) languages.some(function (language) {
      var normalized = (language || "").toLowerCase();
      var candidates = [];

      if (normalized.indexOf("zh") === 0) {
        candidates = ["zh-TW", "zh-Hant", "zh"];
      } else if (normalized.indexOf("ja") === 0) {
        candidates = ["ja", "ja-JP"];
      } else if (normalized.indexOf("ko") === 0) {
        candidates = ["ko", "ko-KR"];
      } else if (normalized.indexOf("es") === 0) {
        candidates = ["es", "es-ES"];
      } else if (normalized.indexOf("ar") === 0) {
        candidates = ["ar", "ar-SA"];
      } else if (normalized.indexOf("en") === 0) {
        candidates = ["en", "en-US"];
      } else {
        candidates = [language];
      }

      return pickAvailable(candidates);
    });

    if (target && target !== current) {
      if (window.localStorage) window.localStorage.setItem(autoLocaleKey, target);
      select.value = target;
      select.form.submit();
    } else if (window.localStorage) {
      window.localStorage.setItem(autoLocaleKey, current || "default");
    }
  })();

  if (!prefersReducedMotion && window.matchMedia("(pointer: fine)").matches) {
    document.addEventListener("pointermove", function (event) {
      document.body.classList.add("la-pointer-active");
      cursorGlow.style.transform =
        "translate3d(" +
        event.clientX +
        "px, " +
        event.clientY +
        "px, 0) translate(-50%, -50%)";
    });

    document.addEventListener("pointerleave", function () {
      document.body.classList.remove("la-pointer-active");
    });

    document.querySelectorAll(".la-tilt-card").forEach(function (card) {
      card.addEventListener("pointermove", function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;

        card.style.setProperty("--tilt-x", (x * 7).toFixed(2) + "deg");
        card.style.setProperty("--tilt-y", (y * -7).toFixed(2) + "deg");
      });

      card.addEventListener("pointerleave", function () {
        card.style.removeProperty("--tilt-x");
        card.style.removeProperty("--tilt-y");
      });
    });

    document.querySelectorAll(".la-shine-card").forEach(function (card) {
      card.addEventListener("pointermove", function (event) {
        var rect = card.getBoundingClientRect();

        card.style.setProperty(
          "--shine-x",
          (((event.clientX - rect.left) / rect.width) * 100).toFixed(2) + "%"
        );

        card.style.setProperty(
          "--shine-y",
          (((event.clientY - rect.top) / rect.height) * 100).toFixed(2) + "%"
        );
      });
    });
  }

  if (!prefersReducedMotion) {
    var parallaxItems = document.querySelectorAll("[data-parallax]");

    function syncParallax() {
      parallaxItems.forEach(function (item) {
        var speed = Number(item.getAttribute("data-parallax")) || 0.06;
        var rect = item.getBoundingClientRect();
        var offset = (window.innerHeight / 2 - (rect.top + rect.height / 2)) * speed;

        item.style.transform = "translateY(" + offset.toFixed(2) + "px)";
      });
    }

    if (parallaxItems.length) {
      syncParallax();
      window.addEventListener("scroll", syncParallax, { passive: true });
      window.addEventListener("resize", syncParallax);
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener("click", function (event) {
      event.preventDefault();
      toggleMobileMenu();
    });
  }

  if (menuClose) {
    menuClose.addEventListener("click", function (event) {
      event.preventDefault();
      closeMobileMenu();
    });
  }

  if (mobileBackdrop) {
    mobileBackdrop.addEventListener("click", function (event) {
      event.preventDefault();
      closeMobileMenu();
    });
  }

  if (mobileNav) {
    mobileNav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMobileMenu);
    });
  }

  /* =========================================================
     FINAL FIX:
     點擊 close、背景遮罩、或選單外部時，都可以關閉 mobile menu
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {
      if (!body.classList.contains("mobile-menu-open")) return;

      var clickedInsideMenu = event.target.closest("[data-mobile-nav]");
      var clickedToggle = event.target.closest("[data-mobile-toggle]");
      var clickedClose = event.target.closest("[data-mobile-close]");
      var clickedBackdrop = event.target.closest("[data-mobile-backdrop]");

      if (clickedClose || clickedBackdrop) {
        event.preventDefault();
        closeMobileMenu();
        return;
      }

      if (!clickedInsideMenu && !clickedToggle) {
        closeMobileMenu();
      }
    },
    true
  );

  document.querySelectorAll("[data-slide]").forEach(function (slider) {
    var row = slider.querySelector("[data-slide-row]");
    var parent = slider.closest("section");
    var previous = parent ? parent.querySelector("[data-slide-prev]") : null;
    var next = parent ? parent.querySelector("[data-slide-next]") : null;

    if (!row) return;

    function slideBy(direction) {
      var firstCard = row.querySelector(".la-slide-card");
      var distance = firstCard ? firstCard.getBoundingClientRect().width + 18 : row.clientWidth * 0.82;

      row.scrollBy({
        left: distance * direction,
        behavior: "smooth"
      });
    }

    if (previous) {
      previous.addEventListener("click", function () {
        slideBy(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        slideBy(1);
      });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMobileMenu();
  });

  var revealItems = document.querySelectorAll("[data-reveal]");

  if ("IntersectionObserver" in window && revealItems.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: "0px 0px -8% 0px"
      }
    );

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add("is-visible");
    });
  }

  var filterRoot = document.querySelector("[data-portfolio-filter]");

  if (filterRoot) {
    var searchInput = filterRoot.querySelector("[data-portfolio-search]");
    var tagButtons = filterRoot.querySelectorAll("[data-portfolio-tag]");
    var cards = document.querySelectorAll("[data-portfolio-card]");
    var emptyState = document.querySelector("[data-portfolio-empty]");
    var activeTag = "";

    function applyPortfolioFilter() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : "";
      var visibleCount = 0;

      cards.forEach(function (card) {
        var title = (card.getAttribute("data-title") || "").toLowerCase();
        var excerpt = (card.getAttribute("data-excerpt") || "").toLowerCase();
        var tags = (card.getAttribute("data-tags") || "").split(",");

        var matchesQuery = !query || title.indexOf(query) > -1 || excerpt.indexOf(query) > -1;
        var matchesTag = !activeTag || tags.indexOf(activeTag) > -1;
        var visible = matchesQuery && matchesTag;

        card.classList.toggle("hidden", !visible);

        if (visible) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.classList.toggle("hidden", visibleCount !== 0);
      }
    }

    if (searchInput) {
      searchInput.addEventListener("input", applyPortfolioFilter);
    }

    tagButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeTag = button.getAttribute("data-portfolio-tag") || "";

        tagButtons.forEach(function (item) {
          var isActive = item === button;

          item.setAttribute("aria-pressed", isActive ? "true" : "false");
          item.classList.toggle("bg-primary", isActive);
          item.classList.toggle("text-primary-foreground", isActive);
          item.classList.toggle("bg-secondary", !isActive);
          item.classList.toggle("text-muted-foreground", !isActive);
        });

        applyPortfolioFilter();
      });
    });
  }

  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var sectionId = form.getAttribute("data-product-form");
    var variantsScript = document.querySelector('[data-product-variants="' + sectionId + '"]');
    var variantInput = form.querySelector("[data-variant-id]");
    var submitButton = form.querySelector(".la-product-submit");
    var priceEl = document.getElementById("ProductPrice-" + sectionId);
    var comparePriceEl = document.getElementById("ProductComparePrice-" + sectionId);

    if (!variantsScript || !variantInput) return;

    var variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      variants = [];
    }

    function formatMoney(cents) {
      var currency = form.getAttribute("data-currency") || "TWD";

      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        return window.Shopify.formatMoney(cents);
      }

      return new Intl.NumberFormat("zh-TW", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: 0
      }).format((cents || 0) / 100);
    }

    function selectedOptions() {
      var values = [];

      form.querySelectorAll(".la-product-options fieldset").forEach(function (fieldset) {
        var checked = fieldset.querySelector("input:checked");

        if (checked) {
          values.push(checked.value);
        }
      });

      return values;
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function updateVariant() {
      var variant = findVariant(selectedOptions()) || variants[0];

      if (!variant) return;

      variantInput.value = variant.id;

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
      }

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available ? themeStrings.addToCart : themeStrings.soldOut;
      }
    }

    form.querySelectorAll(".la-product-options input").forEach(function (input) {
      input.addEventListener("change", updateVariant);
    });

    updateVariant();
  });
})();
